"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Player = exports.getStreamingIdFromUrl = void 0;
const dashjs_1 = __importDefault(require("dashjs"));
const moment_1 = __importDefault(require("moment"));
const react_1 = __importStar(require("react"));
const react_full_screen_1 = require("react-full-screen");
const react_redux_1 = require("react-redux");
const styled_components_1 = __importDefault(require("styled-components"));
const account_1 = require("../../../../base/account");
const functions_1 = require("../../functions");
const playerWebsoket_1 = require("../../playerWebsoket");
const CustomControls_1 = __importStar(require("./CustomControls"));
// @ts-ignore
const PlayerStyled = styled_components_1.default.div `
	flex: 1 1 0%;
	position: relative;
	width: 100%;
	background-repeat: no-repeat;
	display: flex;
	flex-direction: column;
	background-color: rgb(16, 16, 16);
	height: 100%;
	overflow: hidden;
	justify-content: center;
	align-items: flex-end;
`;
function getStreamingIdFromUrl(url) {
    // URL에서 매개변수를 추출하기 위한 함수
    function getParameterByName(name, url) {
        if (!url)
            url = window.location.href;
        name = name.replace(/[\[\]]/g, '\\$&');
        let regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'), results = regex.exec(url);
        if (!results)
            return null;
        if (!results[2])
            return '';
        return decodeURIComponent(results[2].replace(/\+/g, ' '));
    }
    // 주어진 URL에서 streaming_id 매개변수의 값을 가져옵니다.
    let streamingId = getParameterByName('streaming_id', url);
    return streamingId;
}
exports.getStreamingIdFromUrl = getStreamingIdFromUrl;
let player = null;
let websocket = null;
let retryCount = 0;
let timeIntervalId = null;
function getRandomIntervalInMs() {
    // 1분에서 2분 사이의 밀리초 범위
    const minIntervalMs = 1 * 60 * 1000;
    const maxIntervalMs = 2 * 60 * 1000;
    // minIntervalMs와 maxIntervalMs 사이의 랜덤한 밀리초를 생성
    const randomMs = Math.floor(Math.random() * (maxIntervalMs - minIntervalMs + 1)) + minIntervalMs;
    return randomMs;
}
const desiredResolutions = [1080, 720, 360, 180];
exports.Player = react_1.default.memo(({ id, previewId }) => {
    const handle = (0, react_full_screen_1.useFullScreenHandle)();
    const prevIdRef = (0, react_1.useRef)();
    const prevAuthRef = (0, react_1.useRef)();
    const videoRef = (0, react_1.useRef)();
    // 최신 onStop 을 dash 이벤트 핸들러(effect 클로저)에서도 쓰기 위한 ref
    const onStopRef = (0, react_1.useRef)();
    // 창 닫힘 시 일시중지 전송 중복 방지(STOP_STREAMING 경로와 beforeunload/pagehide 경로가 겹칠 수 있음)
    const unloadSentRef = (0, react_1.useRef)(false);
    const waterMarkRef = (0, react_1.useRef)(null); // Correct type
    const [loading, setLoading] = react_1.default.useState(true);
    const [streamingId, setStreamingId] = react_1.default.useState();
    const [streamingAuth, setStreamingAuth] = react_1.default.useState();
    const [mediaUrl, setMediaUrl] = react_1.default.useState();
    const [duration, setDuration] = react_1.default.useState(0);
    const [currentTime, setCurrentTime] = react_1.default.useState(0);
    const [volume, setVolume] = react_1.default.useState(1);
    const [playing, setPlaying] = react_1.default.useState(false);
    const [playRate, setPlayRate] = react_1.default.useState(0);
    // 재생 배속(0.5~2.0). <video>.playbackRate 로 적용, 재생 중 변경 시 서버 시청 기록(speed)도 갱신
    const [playbackRate, setPlaybackRate] = react_1.default.useState(1);
    const [availableQualities, setAvailableQualities] = react_1.default.useState([]);
    const [selectedQuality, setSelectedQuality] = react_1.default.useState('auto');
    // 버퍼링이 완료되었는지 여부를 추적하는 상태
    const maxRetries = 3;
    const user = (0, react_redux_1.useSelector)((state) => (0, account_1.getUserInfo)(state));
    const nickname = (0, react_1.useMemo)(() => {
        if (!user) {
            return `대성마이맥`;
        }
        else {
            return `${user.nickname}(${user.auth_name})`;
        }
    }, [user]);
    // handler 플레이어 시작
    const handlerPlayVideo = async () => {
        try {
            const videoPlayerElement = document.getElementById('videoPlayer') || videoRef.current;
            if (videoPlayerElement) {
                videoPlayerElement.playbackRate = playbackRate;
                await videoPlayerElement.play();
            }
            else {
                player && player.play();
            }
            setPlaying(true);
        }
        catch (err) {
            if (err.name === 'NotAllowedError') {
                console.warn('User interaction required to play the video.');
            }
        }
    };
    // handler 플레이어 정지
    const handlerPauseVideo = async () => {
        try {
            const videoPlayerElement = document.getElementById('videoPlayer') || videoRef.current;
            if (videoPlayerElement) {
                videoPlayerElement.pause();
            }
            else {
                player && player.pause();
            }
            setPlaying(false);
        }
        catch (err) { }
    };
    // updateQualityOptions 함수 수정
    const updateQualityOptions = (0, react_1.useCallback)(() => {
        if (!player) {
            console.warn('Player instance is not available.');
            return;
        }
        const bitrateInfos = player.getBitrateInfoListFor('video');
        if (!bitrateInfos || bitrateInfos.length === 0) {
            console.warn('No bitrate information available.');
            return;
        }
        const qualities = bitrateInfos
            .map((info, index) => ({
            bitrate: Math.round(info.bitrate / 1000),
            height: info.height,
            width: info.width,
            qualityIndex: index,
        }))
            .filter(quality => desiredResolutions.includes(quality.height))
            .sort((a, b) => b.height - a.height);
        if (qualities.length === 0) {
            console.warn('No matching qualities found for the desired resolutions.');
        }
        setAvailableQualities(qualities);
    }, [player]);
    const handleQualityChange = (quality) => {
        if (!player) {
            console.warn('Player instance is not available.');
            return;
        }
        setSelectedQuality(quality);
        if (quality === 'auto') {
            player.updateSettings({
                streaming: {
                    abr: {
                        autoSwitchBitrate: {
                            video: true,
                        },
                    },
                },
            });
        }
        else {
            player.updateSettings({
                streaming: {
                    abr: {
                        autoSwitchBitrate: {
                            video: false,
                        },
                    },
                },
            });
            player.setQualityFor('video', quality);
        }
        // Clear buffer and reinitialize the stream
        // setTimeout(() => {
        // 	player.attachSource(player.getSource());
        // }, 100);
    };
    // Add this function to your component
    const forceQualityUpdate = () => {
        if (player && selectedQuality !== 'auto') {
            player.setQualityFor('video', selectedQuality);
            player.attachSource(player.getSource());
        }
    };
    // 플레이어에 참여하기 (웹소켓 연결)
    const joinStreaming = () => {
        if (websocket) {
            websocket
                .joinStreaming(streamingId)
                .then(
            // @ts-ignore
            async (response) => {
                if (!response)
                    return;
                setMediaUrl(`/api/media/v1/medias/${previewId}/manifest.mpd`);
            })
                .catch(err => {
                alert('스트리밍 오류입니다. 다시 시도해주세요. - 스트리밍 입장 실패');
            });
        }
    };
    // 스트리밍 데이터 로드
    const initLoadData = (0, react_1.useCallback)(() => {
        if (!streamingId)
            return;
        if (player) {
            updateQualityOptions();
            forceQualityUpdate();
            (0, functions_1.getStreaming)({ streamingId }).then((response) => {
                if (!response)
                    return;
                const items = response.result.items;
                if (items && items.length > 0) {
                    const item = items[0];
                    onloadedmetadata(item, player ? player.duration() : 0);
                }
            });
        }
    }, [streamingId]);
    // 비디오 메타데이터 로드
    const onloadedmetadata = async (response, duration) => {
        if (response) {
            const { play_position, speed, status, time, play_time, pause_time } = response;
            if (status === 'stopped') {
                // 재생 시간이 종료 시간보다 작은 경우 처리
                if ((0, moment_1.default)(play_time).isBefore((0, moment_1.default)(pause_time))) {
                    const play_duration = moment_1.default
                        .duration((0, moment_1.default)(pause_time).diff((0, moment_1.default)(play_time)))
                        .asMilliseconds() + play_position;
                    setPlayRate(play_duration / 1000);
                }
                else {
                    setPlayRate(play_position / 1000);
                }
                handlerPauseVideo();
                setLoading(false);
                return;
            }
            const play_duration = moment_1.default
                .duration((0, moment_1.default)(time).diff((0, moment_1.default)(play_time)))
                .asMilliseconds();
            const surveryPosition = play_duration + play_position;
            const localPosition = surveryPosition - websocket.timeDiff;
            if (duration < localPosition / 1000) {
                player && player.seek(0);
                setPlayRate(0);
                handlerPauseVideo();
                setLoading(false);
                return;
            }
            setPlayRate(localPosition / 1000);
            handlerPlayVideo();
            setLoading(false);
        }
    };
    // 팝업 닫기(X 버튼 → STOP_STREAMING). 재생 중이면 서버에 일시중지를 보낸 뒤 창을 닫는다.
    // 종전엔 이 이벤트를 발행하는 곳이 없어 X/닫기 시 일시중지가 전송되지 않았고, 서버는 pause 를
    // 받아야 시청시간을 누적하므로 세션이 running/0 으로 남았다. 네트워크가 늦어도 창은 2초 안에 닫는다
    // (keepalive 라 요청 자체는 창이 닫혀도 전송된다).
    const handlerStop = () => {
        const id = streamingId || prevIdRef.current;
        const auth = streamingAuth || prevAuthRef.current;
        if (playing && id && auth && !unloadSentRef.current) {
            unloadSentRef.current = true;
            const pause = (0, functions_1.stopStreaming)({ streamingAuth: auth, streamingId: id, keepalive: true }).catch(() => { });
            const deadline = new Promise(resolve => setTimeout(resolve, 2000));
            Promise.race([pause, deadline]).finally(() => window.close());
        }
        else {
            window.close();
        }
    };
    react_1.default.useEffect(() => {
        APP.eventManager.subscribe('STOP_STREAMING', handlerStop);
        return () => {
            APP.eventManager.unsubscribe('STOP_STREAMING', handlerStop);
        };
    }, [handlerStop]);
    react_1.default.useEffect(() => {
        timeIntervalId = setInterval(() => {
            const videoPlayerElement = document.getElementById('playerFullElement') ||
                waterMarkRef.current;
            const { offsetWidth: width, offsetHeight: height } = videoPlayerElement;
            // Create and style the canvas element
            const canvasElement = document.createElement('canvas');
            canvasElement.style.position = 'absolute';
            canvasElement.style.top = '0';
            canvasElement.style.left = '0';
            canvasElement.style.width = '100%';
            canvasElement.style.height = '100%';
            canvasElement.width = width;
            canvasElement.height = height;
            const ctx = canvasElement.getContext('2d');
            if (ctx) {
                //
                const watermarkText = nickname || '대성마이맥';
                ctx.font = '25px Arial';
                ctx.fillStyle = 'rgba(255, 255, 255, 0.5)';
                // Calculate text width and height
                const textWidth = ctx.measureText(watermarkText).width * 2;
                const textHeight = 25;
                // Determine random position for the watermark
                const x = Math.max(Math.min(Math.random() * (width - textWidth), width - textWidth - 25), 25);
                const y = Math.max(Math.min(Math.random() * (height - textHeight), height - textHeight - 25), 25);
                // Draw the watermark
                ctx.fillText(watermarkText, x, y);
                const devicePixelRatio = window.devicePixelRatio || 1;
                ctx.scale(devicePixelRatio, devicePixelRatio);
                ctx.setTransform(1, 0, 0, 1, 0, 0);
                if (videoPlayerElement) {
                    videoPlayerElement.appendChild(canvasElement);
                }
            }
            // Remove the canvas after 1 second
            setTimeout(() => {
                if (videoPlayerElement && canvasElement) {
                    videoPlayerElement.removeChild(canvasElement);
                }
            }, 1000);
        }, getRandomIntervalInMs());
        return () => {
            timeIntervalId && clearInterval(timeIntervalId);
        };
    }, [nickname]);
    react_1.default.useEffect(() => {
        return () => {
            if (player) {
                player.reset();
                player.destroy();
                player = null;
            }
            if (websocket) {
                websocket.cleanUp();
                websocket.disconnect();
                websocket = null;
            }
            setLoading(false);
            setMediaUrl(undefined);
        };
    }, []);
    // we
    react_1.default.useEffect(() => {
        if (!previewId)
            return;
        let auth = undefined;
        let streaming_id = undefined;
        setLoading(true);
        (0, functions_1.fetchGetStreamingAuth)(id, previewId).then((response) => {
            if (response.result) {
                streaming_id = getStreamingIdFromUrl(response.result.streaming_url);
                auth = response.result.streaming_auth;
                setStreamingAuth(auth);
                setStreamingId(streaming_id);
            }
        });
        return () => {
            setStreamingAuth(undefined);
            setStreamingId(undefined);
            setMediaUrl(undefined);
        };
    }, [previewId]);
    (0, react_1.useEffect)(() => {
        if (streamingId && streamingAuth) {
            if (websocket)
                return;
            const playerWebsocket = new playerWebsoket_1.PlayerWebsoket();
            playerWebsocket
                .connect()
                .then(() => {
                websocket = playerWebsocket;
                joinStreaming();
            })
                .catch(err => {
                alert('스트리밍 오류입니다. 다시 시도해주세요. - 웹소켓 연결 실패');
                setPlaying(false);
            });
        }
        return () => {
            playing &&
                streamingId &&
                streamingAuth &&
                (0, functions_1.stopStreaming)({
                    streamingAuth,
                    streamingId,
                }).catch(err => { });
            prevIdRef.current = streamingId;
            prevAuthRef.current = streamingAuth;
        };
    }, [streamingId, streamingAuth, playing]);
    // media url 변경된 경우 플레이어 초기화
    react_1.default.useEffect(() => {
        let handlerTimeUpdate; // 재시도 타이머를 관리할 변수
        // 에러가 있을때 재시도
        const handlerError = err => {
            if (retryCount < maxRetries) {
                const retryDelay = Math.pow(2, retryCount) * 1000; // 지수적 백오프
                handlerTimeUpdate = setTimeout(() => {
                    retryCount++;
                    player && player.attachSource(mediaUrl); // 재시도 시 소스 다시 첨부
                }, retryDelay);
            }
            else {
                // alert(err);
                console.log(err);
                // alert('지원되지 않는 기기입니다.');
            }
        };
        const playBackEnded = () => {
            const videoPlayerElement = document.getElementById('videoPlayer') || videoRef.current;
            if (videoPlayerElement) {
                setPlayRate(0);
                // 끝까지 재생돼도 서버에 일시중지를 보내야 시청시간이 누적된다
                // (종전엔 로컬 정지만 해서 끝까지 본 학생이 '미수강 / 0' 으로 남았다)
                if (onStopRef.current) {
                    onStopRef.current();
                }
                else {
                    handlerPauseVideo();
                }
            }
        };
        // 플레이어 초기화
        if (mediaUrl && streamingId && streamingAuth) {
            const dashPlayer = dashjs_1.default.MediaPlayer().create();
            const videoPlayerElement = document.getElementById('videoPlayer') || videoRef.current;
            if (videoPlayerElement) {
                dashPlayer.initialize(videoPlayerElement, undefined, false);
                dashPlayer.on(dashjs_1.default.MediaPlayer.events.STREAM_INITIALIZED, initLoadData);
                dashPlayer.on(dashjs_1.default.MediaPlayer.events.ERROR, handlerError); // 에러 핸들러 등록
                dashPlayer.on(dashjs_1.default.MediaPlayer.events.PLAYBACK_ENDED, playBackEnded); // 재생 종료 핸들러 등록
                dashPlayer.on(dashjs_1.default.MediaPlayer.events.QUALITY_CHANGE_RENDERED, updateQualityOptions); // 재생 종료 핸들러 등록
                dashPlayer.updateSettings({
                    streaming: {
                        buffer: {
                            initialBufferLevel: 4,
                            fastSwitchEnabled: true,
                            bufferPruningInterval: 4, // 1초마다 버퍼 정리
                        },
                        abr: {
                            autoSwitchBitrate: {
                                video: true,
                            },
                        },
                    },
                });
                dashPlayer.attachSource(mediaUrl); // `posix:${125444}`); // 미디어 소스 첨부
                setDuration(dashPlayer.duration());
                player = dashPlayer;
            }
        }
        return () => {
            if (player) {
                player.off(dashjs_1.default.MediaPlayer.events.STREAM_INITIALIZED, initLoadData);
                player.off(dashjs_1.default.MediaPlayer.events.ERROR, handlerError); // 에러 핸들러 해제
                player.off(dashjs_1.default.MediaPlayer.events.PLAYBACK_ENDED, playBackEnded); // 재생 종료 핸들러 해제
                player.off(dashjs_1.default.MediaPlayer.events.QUALITY_CHANGE_RENDERED, updateQualityOptions); // 재생 종료 핸들러 등록
                player.destroy(); // 플레이어 파괴
                if (handlerTimeUpdate)
                    clearTimeout(handlerTimeUpdate); // 타이머 클리어
            }
        };
    }, [mediaUrl]);
    (0, react_1.useEffect)(() => {
        if (player) {
            player.seek(playRate);
        }
    }, [playRate]);
    (0, react_1.useEffect)(() => {
        if (player) {
            player.setVolume(volume);
        }
        if (videoRef.current) {
            videoRef.current.muted = volume > 0 ? false : true;
        }
    }, [volume]);
    // 배속 적용 — 요소와 dash.js 양쪽에 반영. 재생 중이면 서버 play 기록의 speed 도 새 값으로 갱신해
    // 시청 시간 집계가 실제 배속과 어긋나지 않게 한다(정지 중이면 다음 onPlay 가 반영).
    (0, react_1.useEffect)(() => {
        const videoPlayerElement = document.getElementById('videoPlayer') || videoRef.current;
        if (videoPlayerElement)
            videoPlayerElement.playbackRate = playbackRate;
        if (player && typeof player.setPlaybackRate === 'function') {
            try {
                player.setPlaybackRate(playbackRate);
            }
            catch (err) {
                // dash.js 버전에 따라 미지원 — 요소 playbackRate 로 충분
            }
        }
        if (playing && streamingId && streamingAuth && videoPlayerElement) {
            (0, functions_1.playStreaming)({
                streamingAuth,
                streamingId,
                position: Math.floor(videoPlayerElement.currentTime * 1000),
                speed: Math.round(playbackRate * 1000),
            }).catch(() => {
                // 기록 갱신 실패는 재생을 막지 않는다
            });
        }
    }, [playbackRate]);
    // 플레이어 시간 변경
    const onTimeChange = async (currentTime) => {
        const videoPlayerElement = document.getElementById('videoPlayer') || videoRef.current;
        if (videoPlayerElement) {
            videoPlayerElement.currentTime = currentTime;
            if (player) {
                const isPlaying = playing;
                await onPlay();
                if (!isPlaying)
                    await onStop();
                // await onPlay();
            }
        }
    };
    // 플레이어 재생
    const onPlay = async () => {
        if (!streamingId || !streamingAuth) {
            alert('스트리밍 정보가 없습니다.');
            window.close();
            return;
        }
        const videoPlayerElement = document.getElementById('videoPlayer') || videoRef.current;
        handlerPlayVideo();
        setPlaying(true);
        let position = 0;
        let speed = 1;
        if (videoPlayerElement) {
            position = Math.floor(videoPlayerElement.currentTime * 1000);
            speed = videoPlayerElement.playbackRate * 1000;
        }
        try {
            await (0, functions_1.playStreaming)({
                streamingAuth,
                streamingId,
                position,
                speed,
            });
        }
        catch (err) {
            alert('스트리밍 재생에 실패했습니다.');
        }
    };
    // 플레이어 정지
    const onStop = async () => {
        if (!streamingId || !streamingAuth)
            return;
        handlerPauseVideo();
        setPlaying(false);
        try {
            await (0, functions_1.stopStreaming)({
                streamingAuth,
                streamingId,
            });
        }
        catch (err) {
            alert('스트리밍 중지에 실패했습니다.');
            setPlaying(true);
        }
    };
    onStopRef.current = onStop;
    // PC 키보드 좌/우 방향키로 10초 이동(모바일/태블릿은 CustomControls 의 좌·우 더블탭).
    // 최신 핸들러를 ref 로 물려 리스너는 한 번만 등록한다(재생 중 currentTime 갱신으로 재등록되지 않게).
    const seekHandlerRef = (0, react_1.useRef)();
    seekHandlerRef.current = onTimeChange;
    (0, react_1.useEffect)(() => {
        const handlerKeyDown = (e) => {
            if (e.key !== 'ArrowLeft' && e.key !== 'ArrowRight')
                return;
            const target = e.target;
            const tagName = target?.tagName?.toLowerCase();
            // 입력 요소(볼륨 슬라이더 등)에서는 기본 동작을 방해하지 않는다
            if (tagName === 'input' || tagName === 'textarea' || target?.isContentEditable)
                return;
            const videoPlayerElement = document.getElementById('videoPlayer') || videoRef.current;
            if (!videoPlayerElement || !videoPlayerElement.duration)
                return;
            e.preventDefault();
            const delta = e.key === 'ArrowLeft' ? -CustomControls_1.SEEK_STEP_SECONDS : CustomControls_1.SEEK_STEP_SECONDS;
            const next = Math.min(Math.max(videoPlayerElement.currentTime + delta, 0), videoPlayerElement.duration);
            seekHandlerRef.current?.(next);
        };
        window.addEventListener('keydown', handlerKeyDown);
        return () => window.removeEventListener('keydown', handlerKeyDown);
    }, []);
    // 창 닫힘·탭 이탈 시 마지막 일시중지 전송. 일반 fetch 는 unload 중 취소되므로 keepalive 로 보낸다.
    // beforeunload 와 pagehide(모바일 사파리는 beforeunload 를 안 쏨) 둘 다 걸고 한 번만 보낸다.
    const beforeUnload = () => {
        if (unloadSentRef.current)
            return;
        const id = streamingId || prevIdRef.current;
        const auth = streamingAuth || prevAuthRef.current;
        if (playing && id && auth) {
            unloadSentRef.current = true;
            (0, functions_1.stopStreaming)({ streamingAuth: auth, streamingId: id, keepalive: true }).catch(() => { });
        }
    };
    // bfcache 로 되돌아온 경우(pagehide 후 pageshow) 다시 닫을 때도 전송되게 플래그 초기화
    const onPageShow = () => {
        unloadSentRef.current = false;
    };
    (0, react_1.useEffect)(() => {
        window.addEventListener('beforeunload', beforeUnload);
        window.addEventListener('pagehide', beforeUnload);
        window.addEventListener('pageshow', onPageShow);
        return () => {
            window.removeEventListener('beforeunload', beforeUnload);
            window.removeEventListener('pagehide', beforeUnload);
            window.removeEventListener('pageshow', onPageShow);
        };
    }, [beforeUnload]);
    return (react_1.default.createElement(react_full_screen_1.FullScreen, { className: "fullscreen", handle: handle },
        react_1.default.createElement(PlayerStyled, { id: "playerFullElement", ref: waterMarkRef },
            react_1.default.createElement("video", { ref: videoRef, id: "videoPlayer", 
                // @ts-ignore
                onTimeUpdate: e => setCurrentTime(e.target.currentTime), 
                // @ts-ignore
                onLoadedMetadata: e => setDuration(e.target.duration), playsInline: true, controls: false, muted: volume === 0, disablePictureInPicture: true, preload: "metadata", style: { visibility: loading ? 'hidden' : 'visible' } }),
            react_1.default.createElement(CustomControls_1.default, { videoRef: waterMarkRef, playing: playing, onPlay: onPlay, onPause: onStop, duration: duration, currentTime: currentTime, onSeek: onTimeChange, volume: volume, onVolumeChange: setVolume, handlerFullScreen: handle.enter, handlerExitFullScreen: handle.exit, availableQualities: availableQualities, selectedQuality: selectedQuality, handleQualityChange: handleQualityChange, playbackRate: playbackRate, onPlaybackRateChange: setPlaybackRate }),
            react_1.default.createElement("div", { className: "loading" }, "\uB85C\uB529\uC911..."))));
});
